import SectionApp from './SectionApp'

export default SectionApp
